module.exports = {"421223100":"天城镇","421223101":"沙坪镇","421223102":"石城镇","421223103":"桂花泉镇","421223104":"白霓镇","421223105":"路口镇","421223106":"金塘镇","421223107":"青山镇","421223200":"肖岭乡","421223201":"铜钟乡","421223202":"港口乡","421223203":"高枧乡","421223570":"崇阳县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421223.json
// module id = 1910
// module chunks = 0